import * as types from "../types";

export const getExperts = ({ name }) => ({
  type: types.GET_EXPERTS,
  request: {
    url: "/experts",
    method: "GET",
    params: {
      "q[public_name_cont]": name
    }
  }
});

export const getExpert = ({ id }) => ({
  type: types.GET_EXPERT,
  request: {
    url: `/experts/${id}`,
    method: "GET"
  }
});

export const updateExpert = ({ id, expert }) => ({
  type: types.UPDATE_EXPERT,
  request: {
    url: `/experts/${id}`,
    method: "PATCH",
    data: {
      expert
    }
  },
  meta: {
    mutations: {
      [types.GET_EXPERT]: ({ data }) => {
        return { data: { ...data, ...expert } };
      }
    }
  }
});
